/* istanbul ignore file */

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { RecoilRoot } from 'recoil';
// The linter throws an error here on CI/CD because the file doesn't exist yet, so ignore this error for this line.
// eslint-disable-next-line import/no-unresolved
import './styles/tailwind.generated.css';
import FlagProvider, { UnleashClient } from '@unleash/proxy-client-react';
import { shouldMockBackend } from 'test-utils/mocks/should-mock-backend';

/* istanbul ignore next */
if (shouldMockBackend()) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./test-utils/mocks/mock-backend-browser');
  worker.start();
}

const unleashConfig = {
  url: process.env.UNLEASH_PROXY_URL,
  clientKey: process.env.UNLEASH_PROXY_SECRET,
  refreshInterval: process.env.UNLEASH_REFRESH_INTERVAL || 5,
  appName: process.env.UNLEASH_APP_NAME || 'dev',
  environment: process.env.UNLEASH_APP_NAME || 'dev',
};

const client = new UnleashClient(unleashConfig);

ReactDOM.render(
  <React.StrictMode>
    <FlagProvider unleashClient={client}>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </FlagProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
